export async function setNoibuCustomAttribute(name, value) {
  if (!window.NOIBUJS) {
    await Promise.race([
      new Promise(resolve => {
        window.addEventListener('noibuSDKReady', resolve)
      }),
      new Promise(resolve => setTimeout(resolve, 1000))
    ])
  }

  if (window.NOIBUJS) {
    window.NOIBUJS.addCustomAttribute(name, value)
  }
}
